
import React								from 'react';
import ReactDOM								from 'react-dom';
import {Provider}							from 'react-redux';
import {BrowserRouter}						from 'react-router-dom';
import {registerLocale, setDefaultLocale}	from 'react-datepicker';
import * as Sentry							from '@sentry/react';
import fr									from 'date-fns/locale/fr';
import 'moment/dist/locale/fr';

import {store}								from './app/store';

import App									from './App';

import './index.css';
import './ressources/css/varColorClass.css';
import './ressources/css/fontWeightClass.css';
import './ressources/css/animation.css';
import './ressources/css/global.css';
import './ressources/css/text.css';

registerLocale('fr', fr);
setDefaultLocale('fr');

Sentry.init({
	dsn:          'https://8a2095c7b86031dd8da69a040ebb7a6b@o4507543776198656.ingest.de.sentry.io/4507543777706064',
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration()
	],
	// Performance Monitoring
	tracesSampleRate:         1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets:  ['localhost', /^https:\/\/yourserver\.io\/api/],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);
